/**
 * SMS segment hesabı — sadece bilgilendirme, sert limit yok.
 * Sağlayıcı opt-out metnini kendisi ekler (metni gömmeyin).
 */
export const SMS_SEGMENT_CHARS = 160;
export const SMS_PROVIDER_FOOTER_CHARS = 45;

export function smsWireLength(contentChars) {
  return Math.max(0, Number(contentChars) || 0) + SMS_PROVIDER_FOOTER_CHARS;
}

export function smsSegmentCount(contentChars) {
  const wire = smsWireLength(contentChars);
  if (wire <= 0) return 0;
  return Math.max(1, Math.ceil(wire / SMS_SEGMENT_CHARS));
}

/** @deprecated no hard limit */
export const SMS_MAX_SEGMENTS = Infinity;
/** @deprecated no hard limit */
export const SMS_MAX_WIRE_CHARS = Infinity;
/** @deprecated no hard limit */
export const SMS_MAX_CONTENT_CHARS = 10000;

export function smsOverLimit() {
  return false;
}
